import useDefaultLanguage from '@hooks/useDefaultLanguage';
import { ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

function LanguageProvider({ children }:Props) {
    useDefaultLanguage();
    return children;
}

export default LanguageProvider;
